import script from "./RangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./RangeSlider.vue?vue&type=style&index=0&id=6226af24&lang=scss"

const __exports__ = script;

export default __exports__